export const Supportnotesbox = {
    selectors: {
        openSelector: document.querySelector('.js-supportnotesbox--open'),
        closeSelector: document.querySelector('.js-supportnotesbox--close'),
        iconSelector: document.querySelector('.js-supportnotesbox--icon'),
        headerCountSelector: document.querySelector('.js-supportnotesbox--headercount'),
        wholeSelector: document.querySelector('.js-supportnotesbox'),
        ajaxSelector: document.querySelector('.js-supportnotesbox--ajax'),
        contentSelector: document.querySelector('.js-supportnotesbox--content'),
        addButtonSelector: document.querySelector('.js-supportnotesbox--add'),
        inputSelector: document.querySelector('.js-supportnotesbox--input'),
        likeSelector: Array.prototype.slice.call(document.querySelectorAll('.js-supportnotebox--like')),
        adminboxOpenSelector: document.querySelector('.js-adminbox--open'),
        adminboxContentSelector: document.querySelector('.js-adminbox--content'),
    },

    init: function() {
        let self = this;

        if (self.selectors.wholeSelector) {
            self.selectors.openSelector.addEventListener('click', function (event) {
                self.toggleSupportnotesbox();
                self.renderContent(this);
            });
            self.selectors.closeSelector.addEventListener('click', function (event) {
                self.toggleSupportnotesbox();
            });
            self.selectors.addButtonSelector.addEventListener('click', function (event) {
                self.addNote(this, self.selectors.inputSelector);
            });
            self.selectors.ajaxSelector.addEventListener('click', function (event) {
                 if (event.target.classList.contains('js-supportnotebox--like')) {
                     self.likeEvent(event.target);
                 }
            });
        }
    },
    toggleSupportnotesbox: function () {
        let self = this;
        if (!self.selectors.contentSelector.classList.contains('is-active')) {
            self.selectors.contentSelector.classList.add('is-active');
            self.selectors.openSelector.classList.add('u-hidden');
            self.selectors.iconSelector.classList.add('u-hidden');
            return;
        }
        self.selectors.contentSelector.classList.remove('is-active');
        self.selectors.openSelector.classList.remove('u-hidden');
        self.selectors.iconSelector.classList.remove('u-hidden');

        if (self.selectors.adminboxOpenSelector) {
            if (self.selectors.adminboxOpenSelector.classList.contains('u-hidden')) {
                self.selectors.supportNotesContentSelector.classList.remove('is-active');
                self.selectors.adminboxOpenSelector.classList.add('u-hidden');
            }
        }
    },
    renderContent: function (_selector) {
        let self = this;
        let url = _selector.dataset.url;
        self.ajaxRequest(url, 'GET', null)
            .then((result) => {self.updateSupportnotesbox(result)}, self.errorHandler);
    },
    addNote: function (_buttonSelector, _inputSelector) {
        let self = this;
        let url = _buttonSelector.dataset.url;
        let note = _inputSelector.value;
        if (note === '') {
            return;
        }
        self.ajaxRequest(url, 'GET', note)
            .then((result) => {self.afterAdd(result, _buttonSelector, _inputSelector)}, self.errorHandler);
    },
    updateSupportnotesbox: function (_response) {
        let self = this;
        self.selectors.ajaxSelector.innerHTML = _response.content;
        self.selectors.iconSelector.innerHTML = _response.count;
        self.selectors.headerCountSelector.innerHTML = _response.count;
    },
    afterAdd: function (result, _buttonSelector, _inputSelector) {
        let self = this;
        if (result.success) {
            let refresh = _buttonSelector.dataset.refresh;
            self.ajaxRequest(refresh, 'GET', null)
                .then((result) => {self.updateSupportnotesbox(result)}, self.errorHandler);
            _inputSelector.value = '';
        } else {
            alert(result.message);
        }
    },
    likeEvent: function (_selector) {
        let self = this;
        let url = _selector.dataset.url;

        self.ajaxRequest(url, 'GET', null)
            .then((result) => {self.updateSupportnotesbox(result)}, self.errorHandler);
    },
    ajaxRequest: function(_serviceURL, _method, _note) {
        let promiseObj = new Promise(function(resolve, reject) {
            let requestURL = _serviceURL;
            let request = new XMLHttpRequest();
            if (_note) {
                requestURL = requestURL + '?note=' + _note;
            }

            request.open(_method, requestURL);
            request.responseType = 'json';
            request.send();

            request.onreadystatechange = function() {
                if (request.readyState === 4){
                    if (request.status === 200){
                        resolve(request.response);
                    } else {
                        reject(request.status);
                        console.log("xhr failed");
                    }
                }
            }
        });
        return promiseObj;
    },

    errorHandler: function(_statusCode) {
        console.log("failed with status", _statusCode);
    },
};

Supportnotesbox.init();
